var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingOverview = function SvgBillingOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -10.21,
    y1: 207.6,
    x2: 139.19,
    y2: 14.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -62.59,
    y1: 167.12,
    x2: 86.82,
    y2: -26.22,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -31.94,
    y1: 190.81,
    x2: 117.47,
    y2: -2.54,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -34.51,
    y1: 188.82,
    x2: 114.89,
    y2: -4.53,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -20.47,
    y1: 199.67,
    x2: 128.93,
    y2: 6.32,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -2.6,
    y1: 213.47,
    x2: 146.8,
    y2: 20.13,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 24.22,
    y1: 234.2,
    x2: 173.62,
    y2: 40.86,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 3.51,
    y1: 218.2,
    x2: 152.91,
    y2: 24.85,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 43.75,
    y1: 249.3,
    x2: 193.16,
    y2: 55.95,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -62.59,
    y1: 167.12,
    x2: 86.82,
    y2: -26.22,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -31.94,
    y1: 190.81,
    x2: 117.47,
    y2: -2.54,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -34.51,
    y1: 188.82,
    x2: 114.89,
    y2: -4.53,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -20.47,
    y1: 199.67,
    x2: 128.93,
    y2: 6.32,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -2.6,
    y1: 213.47,
    x2: 146.8,
    y2: 20.13,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 24.22,
    y1: 234.2,
    x2: 173.62,
    y2: 40.86,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 3.51,
    y1: 218.2,
    x2: 152.91,
    y2: 24.85,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 43.75,
    y1: 249.3,
    x2: 193.16,
    y2: 55.95,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.41,149.14c-1.73,0-3.12,1.4-3.12,3.12v35.08c0,2.83-2.3,5.13-5.13,5.13H10.65c-2.83,0-5.13-2.3-5.13-5.13V12.74c0-2.83,2.3-5.13,5.13-5.13h94.34v25.73c0,3.59,2.92,6.51,6.51,6.51h28.79v21.22c0,1.73,1.4,3.12,3.12,3.12s3.12-1.4,3.12-3.12v-24.34c0-.65-.36-1.67-.99-2.27-.32-.3-35.01-32.01-35.32-32.28,0,0,0,0,0,0h0c-.56-.51-1.47-.82-2.1-.82H10.65C4.37,1.37-.73,6.47-.73,12.74v174.6c0,6.27,5.1,11.38,11.38,11.38h124.51c6.27,0,11.38-5.1,11.38-11.38v-35.08c0-1.73-1.4-3.12-3.12-3.12h0ZM111.49,33.6c-.14,0-.26-.12-.26-.26V11.57c2.94,2.68,22.24,20.32,24.11,22.03h-23.86Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91,30.63h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,56.52c0-1.73-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h107.84c1.73,0,3.12-1.4,3.12-3.12Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,82.41H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91,117.67h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92,140.44H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h67.01c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79,172.58c0,1.73,1.4,3.12,3.12,3.12h107.84c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12h0Z",
    style: {
      fill: "url(#h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,76.77c-13.96,2.97-23.35,15.02-24.04,28.15-.09,1.72,1.23,3.2,2.96,3.29.05,0,.11,0,.17,0,1.65,0,3.03-1.29,3.12-2.96.55-10.56,8.15-20.04,19.1-22.37,1.69-.36,2.77-2.02,2.41-3.71s-2.01-2.77-3.71-2.41h0Z",
    style: {
      fill: "url(#i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,146.15l-6.08-4.84c-1.35-1.07-3.32-.85-4.39.5-1.08,1.35-.85,3.32.5,4.39l6.08,4.84c3.33,2.65,3.88,7.5,1.23,10.83-2.68,3.36-7.51,3.86-10.83,1.23l-21.25-16.92,9.6-12.06,4.7,3.74c1.35,1.08,3.32.85,4.39-.5,1.08-1.35.85-3.32-.5-4.39l-7.14-5.69c-1.37-1.09-3.33-.83-4.39.5l-.37.47-5.75-4.58c7.73-17.84,2.67-38.44-12.7-50.65-10.18-8.05-23.31-11.03-35.81-8.31-35.11,7.47-46.1,52.93-17.66,75.53,15.77,12.55,38.41,12.3,53.83-.24l5.34,4.25-.37.47c-1.08,1.35-.85,3.32.5,4.39l23.7,18.87c6.01,4.78,14.79,3.84,19.61-2.22,4.81-6.03,3.81-14.8-2.22-19.61h0ZM97.52,135.35c-24.37-19.37-14.79-58.17,15.09-64.53,11-2.39,22.21.44,30.65,7.13,15.29,12.14,18.41,33.92,7.11,49.86l-1.13,1.54c-16.42,17.77-37.59,17.25-51.72,6.01h0ZM155.46,131.44s0,0,0,0h0s.01-.03.02-.04c.48-.68.94-1.36,1.37-2.07l4.78,3.81-4.96,6.23-4.64-3.69c1.67-1.83,2.67-3.18,3.41-4.23h0Z",
    style: {
      fill: "url(#j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.41,149.14c-1.73,0-3.12,1.4-3.12,3.12v35.08c0,2.83-2.3,5.13-5.13,5.13H10.65c-2.83,0-5.13-2.3-5.13-5.13V12.74c0-2.83,2.3-5.13,5.13-5.13h94.34v25.73c0,3.59,2.92,6.51,6.51,6.51h28.79v21.22c0,1.73,1.4,3.12,3.12,3.12s3.12-1.4,3.12-3.12v-24.34c0-.65-.36-1.67-.99-2.27-.32-.3-35.01-32.01-35.32-32.28,0,0,0,0,0,0h0c-.56-.51-1.47-.82-2.1-.82H10.65C4.37,1.37-.73,6.47-.73,12.74v174.6c0,6.27,5.1,11.38,11.38,11.38h124.51c6.27,0,11.38-5.1,11.38-11.38v-35.08c0-1.73-1.4-3.12-3.12-3.12h0ZM111.49,33.6c-.14,0-.26-.12-.26-.26V11.57c2.94,2.68,22.24,20.32,24.11,22.03h-23.86Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91,30.63h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z",
    style: {
      fill: "url(#k)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,56.52c0-1.73-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h107.84c1.73,0,3.12-1.4,3.12-3.12Z",
    style: {
      fill: "url(#l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,82.41H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#m)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91,117.67h54.78c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12Z",
    style: {
      fill: "url(#n)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92,140.44H17.91c-1.73,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12h67.01c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#o)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79,172.58c0,1.73,1.4,3.12,3.12,3.12h107.84c1.73,0,3.12-1.4,3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73,0-3.12,1.4-3.12,3.12h0Z",
    style: {
      fill: "url(#p)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,76.77c-13.96,2.97-23.35,15.02-24.04,28.15-.09,1.72,1.23,3.2,2.96,3.29.05,0,.11,0,.17,0,1.65,0,3.03-1.29,3.12-2.96.55-10.56,8.15-20.04,19.1-22.37,1.69-.36,2.77-2.02,2.41-3.71s-2.01-2.77-3.71-2.41h0Z",
    style: {
      fill: "url(#q)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,146.15l-6.08-4.84c-1.35-1.07-3.32-.85-4.39.5-1.08,1.35-.85,3.32.5,4.39l6.08,4.84c3.33,2.65,3.88,7.5,1.23,10.83-2.68,3.36-7.51,3.86-10.83,1.23l-21.25-16.92,9.6-12.06,4.7,3.74c1.35,1.08,3.32.85,4.39-.5,1.08-1.35.85-3.32-.5-4.39l-7.14-5.69c-1.37-1.09-3.33-.83-4.39.5l-.37.47-5.75-4.58c7.73-17.84,2.67-38.44-12.7-50.65-10.18-8.05-23.31-11.03-35.81-8.31-35.11,7.47-46.1,52.93-17.66,75.53,15.77,12.55,38.41,12.3,53.83-.24l5.34,4.25-.37.47c-1.08,1.35-.85,3.32.5,4.39l23.7,18.87c6.01,4.78,14.79,3.84,19.61-2.22,4.81-6.03,3.81-14.8-2.22-19.61h0ZM97.52,135.35c-24.37-19.37-14.79-58.17,15.09-64.53,11-2.39,22.21.44,30.65,7.13,15.29,12.14,18.41,33.92,7.11,49.86l-1.13,1.54c-16.42,17.77-37.59,17.25-51.72,6.01h0ZM155.46,131.44s0,0,0,0h0s.01-.03.02-.04c.48-.68.94-1.36,1.37-2.07l4.78,3.81-4.96,6.23-4.64-3.69c1.67-1.83,2.67-3.18,3.41-4.23h0Z",
    style: {
      fill: "url(#r)",
      strokeWidth: 0
    }
  }));
};
export default SvgBillingOverview;